import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import AuthPage from "@/components/auth-page";
import { SSOView } from "@/components/sso/sso-view";

const ssoSchema = z.object({
  slug: z.string().optional().catch(undefined),
  handle: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/sso")({
  beforeLoad: async ({ context }) => {
    const authConfig = await context.auth.getAuthConfig();

    if (authConfig.status === "authenticated") {
      return redirect({ to: "/home" });
    }
  },
  component: SSOPage,
  validateSearch: ssoSchema,
});

function SSOPage() {
  const navigate = useNavigate();
  const { slug, handle } = Route.useSearch();
  return (
    <AuthPage title="Single Sign-on">
      <SSOView
        slug={slug}
        handle={handle}
        onSignIn={() => {
          void navigate({ to: `/sign-in` });
        }}
      />
    </AuthPage>
  );
}
